import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(default)/blog/what-is-an-image-prompt/page.tsx");
